<template>
  <b-container :style=guest.cardColor class="guest-card" fluid>
    <b-row class="flex-column-reverse flex-md-row">
      <b-col md="8" class="guest-container">
        <b-row>
          <b-col>
            <p class="text-white name">{{ guest.name }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="text-white position-company">{{ guest.position }}</p>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4">
        <b-row align-h="end">
          <b-col class="avatar">
            <a :href="guest.linkedinURL" target="_blank">
              <b-avatar
                class="avatar-image"
                :alt="guest.photoFileName"
                :src="require('../assets/guests/' + guest.photoFileName)"
              ></b-avatar>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex-column-md-reverse flex-md-row">
      <b-col md="8">
        <b-row>
          <b-col class="speech-container">
            <b-row>
              <b-col>
                <p class="text-white title">
                  {{ truncate_name(guest.title, 45, '...') }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="text-white date">{{ guest.datePretty }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span v-if="guest.daysLeft > 0">
                  <p class="text-white days-left">
                    {{ Math.ceil(guest.daysLeft) }} days away
                  </p>
                </span>
                <span v-else>
                  <p class="text-white days-left">2020</p>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        md="4"
        class="d-flex justify-content-center justify-content-md-end align-items-end"
      >
        <b-row>
          <b-col v-if="guest.presentationPage != ''">
            <a
              :href="guest.presentationPage"
              target="_blank"
            >
              <b-button class="calendar-button-episode">
                <b-icon icon="play"></b-icon> Full Episode
              </b-button>
            </a>
          </b-col>
          <b-col v-else>
            <a
              href="https://www.youtube.com/channel/UCmBU4QACrBqAAOTItIRX9nA/videos"
              target="_blank"
            >
              <b-button class="calendar-button-episode">
                Video
              </b-button>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/_components/guest-card.sass
</style>

<script>
export default {
  props: ['guest'],
  name: 'GuestCard',
  methods: {
    truncate_name(text, length, clamp) {
      clamp = clamp || '...'
      var node = document.createElement('div')
      node.innerHTML = text
      var content = node.textContent
      return content.length > length
        ? content.slice(0, length) + clamp
        : content
    },
  },
}
</script>
